export default {
  // Access Groups
  rap_crm: 'CRM',
  rap_reportsRAP: 'Reports',
  rap_wallboard: 'Wallboard',
  rap_sms: 'SMS',
  rap_webchat: 'Webchat',
  rap_qaqc: 'Performance Review',
  rap_fax: 'Fax',
  rap_videoConference: 'Video Conference',
  rap_userSettings: 'User Settings',
  rap_callcenter: 'Call Center',
  rap_callSettings: 'Call Settings',
  rap_connectToCrm: 'Connect to CRM',
  // rap_navatelSupport: 'Navatel Support'

  // Accesses
  rap_ci_companies: 'Companies',
  rap_timeline: 'History of Activities',
  rap_ci_persons: 'Contacts',
  rap_lead: 'Leads',
  rap_convert: 'Convert Lead to Contact',
  rap_deal: 'deals',
  rap_ticket: 'Tickets',
  rap_answer: 'Reply',
  rap_change_status: 'Change Status',
  rap_task: 'Tasks',
  rap_comment: 'Comment',
  rap_invoice: 'Invoices',
  rap_invoice_settings: 'Invoice Settings',
  rap_product: 'Products',
  rap_add_product: 'Add Product',
  rap_inventory: 'Inventory',
  rap_sms_contacts: 'Phonebook',
  rap_sms_single_send: 'Single',
  rap_sms_group_send: 'Group',
  rap_sms_bulk_send: 'Bulk',
  rap_sms_p2p_send: 'Correspondent',
  rap_sms_parametric_send: 'Parametric',
  rap_sms_developers_section: 'Programmers Special',
  rap_sms_messages_detail: 'Send Report',
  rap_sms_inbounds: 'Receive Report',

  // Reports
  rap_call_logs: 'Call Logs',
  rap_call_report_unanswerd: 'Call Status',
  rap_operators_activity: 'Agent Performance',
  rap_call_records: 'Call Records',
  rap_full_call_records: 'Advanced Call Report',
  rap_rating: 'Call Survey Results',
  rap_call_scattering: 'Call Scatter Chart',
  rap_cost_log: 'Cost Chart',
  rap_customer_waiting: 'Customer Wait Chart',
  rap_call_report_missed: 'Missed Calls',

  // Monitoring
  rap_live_monitoring: 'Agent Monitoring',

  // SMS
  rap_message_single: 'Single SMS',
  rap_message_group: 'Group',
  rap_message_bulk: 'Bulk',
  rap_message_send_report: 'Send Report',
  rap_message_receive_report: 'Receive Report',
  rap_message_corresponding: 'Correspondent SMS',
  rap_message_otp: 'Programmers Special',
  rap_message_parametric: 'Parametric SMS',
  rap_bulk_send: 'Bulk',
  rap_contact_add: 'Add Contact',
  rap_contact_delete: 'Delete Contact',
  rap_contact_report: 'Contact Reports',
  rap_contact_update: 'Edit Contact',
  rap_contact_view: 'View Contacts',
  rap_developers_section: 'Programmers Special',
  rap_add_group: 'Add Group',
  rap_delete_group: 'Delete Group',
  rap_edit_group: 'Edit Group',
  rap_send_group: 'Group',
  rap_view_group: 'View Group',
  // rap_message_to_operator: '',

  // Webchat
  rap_webchat_counter: 'Dashboard',
  rap_webchat_declare_website: 'Add Website',
  rap_webchat_operator_management: 'Agents',
  rap_webchat_department: 'Departments',
  rap_webchat_personalization: 'Settings & Customization',
  rap_webchat_chats: 'Conversations',

  // QAQC
  rap_evaluations: 'Performance Evaluation',
  rap_evaluation_report: 'Users Performance',

  // Fax
  rap_fax_create: 'Create Fax',
  rap_fax_send: 'Send Fax',
  rap_fax_sent_report: 'Sent Faxes',
  rap_fax_recv_report: 'Received Faxes',

  // Video Conference
  rap_conf_create_link: 'Create Link',
  rap_conf_report: 'Reports',

  // Call Settings
  rap_call_forward: 'Call Forward Number',
  rap_add_user: 'Call Forward Number',
  rap_upload_voice: 'Upload Audio File',
  rap_queue: 'Queue Management',
  rap_ivr_menu: 'IVR Management',
  rap_time_cond: 'Set Time Conditions',
  rap_voicemail_management: 'Voicemail Management',
  rap_block_list: 'Blacklist',
  rap_destinations: 'Call Destination',

  // User Settings
  rap_role_management: 'User Management',
  rap_department: 'Department',
  rap_permission_management: 'Roles & Permissions',
  rap_message_to_operator: 'Send Message to Users',
  rap_whatsapp: 'WhatsApp',
  rap_stream_record_sound: 'Audio call records',

  // Connect to CRM
  rap_crm_authorized_numbers: 'Define CRM Numbers',
  rap_crm_links: 'CRM Structure',
  rap_crm_settings: 'CRM Links',

  //automation
  rap_automation: 'Automation',
  rap_workflow: 'Workflow',

  // Base Permissions
  rap_add: 'Add',
  rap_delete: 'Delete',
  rap_edit: 'Edit',
  rap_view: 'View',

  // Custom Permissions
  rap_assign: 'Assign',
  rap_convert_to_contact: 'Convert to Contact',
  rap_convert_to_invoice: 'Convert Proforma Invoice to Invoice',
  rap_create_category: 'Create Category',
  rap_delete_category: 'Delete Category',
  rap_edit_category: 'Edit Category',
  rap_report: 'Report',
  rap_upload: 'Upload',
  rap_close: 'Close',
  rap_delete_agent: 'Delete Operator',
  rap_invoke: 'Cancel',
  rap_add_pre_invoice: 'Add Proforma Invoice',
  rap_add_invoice: 'Add Invoice',
  rap_add_and_edit: 'Add and Edit',
  rap_messaging_in_whatsapp: 'Messaging on WhatsApp',
  rap_whatsapp_settings: 'WhatsApp Settings',
  rap_stream_record_sound_view: 'Play and download audio call records',
  rap_title_options: 'Register, edit, and delete default titles',

  // Policies
  rap_all: 'All module records',
  rap_self: 'Own records',
  rap_self_and_department_mates: 'Own and department records',
  rap_self_and_role_mates: 'Own and same-role records in department',
};
